import { AAM2_BASE_PATH, MY_NAME_BASE_PATH, FAMOUS_RELATIVES_BASE_PATH } from '../experiences/routePaths'
import { TEMPLE_BASE_PATH } from '../../temple/constants'

/**
 * The colour each activity fills its screen with while it loads.
 *
 * Kept in sync by hand with discovery-kids' src/constants/activityCoverColors.js and the inline
 * script in this app's public/index.html, neither of which can import from here.
 */
export const MY_YEAR_BACKGROUND = '#018293'
export const MY_NAME_BACKGROUND = '#50367c'
export const FAMOUS_RELATIVES_BACKGROUND = '#ca3a59'
export const TEMPLE_BACKGROUND = '#e7e8df'

const ACTIVITY_BACKGROUNDS = {
  [AAM2_BASE_PATH]: MY_YEAR_BACKGROUND,
  [MY_NAME_BASE_PATH]: MY_NAME_BACKGROUND,
  [FAMOUS_RELATIVES_BASE_PATH]: FAMOUS_RELATIVES_BACKGROUND,
  [TEMPLE_BASE_PATH]: TEMPLE_BACKGROUND,
}

export function getActivityBackground(pathname = '') {
  const base = Object.keys(ACTIVITY_BACKGROUNDS).find((path) => pathname.includes(path))
  return base ? ACTIVITY_BACKGROUNDS[base] : null
}

const relativeLuminance = (hex) => {
  const channels = [1, 3, 5].map((start) => Number.parseInt(hex.slice(start, start + 2), 16) / 255)
  const linear = (value) => (value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4)
  const [red, green, blue] = channels.map(linear)
  return 0.2126 * red + 0.7152 * green + 0.0722 * blue
}

export const DARK_TEXT = '#1b1b1b'
export const LIGHT_TEXT = '#ffffff'

export function readableTextColor(background) {
  try {
    return relativeLuminance(background) > 0.4 ? DARK_TEXT : LIGHT_TEXT
  } catch {
    return LIGHT_TEXT
  }
}
